import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchId,
  fetchIdNoloading,
  selectId,
  selectLoading,
  uploadItem,
  uploadValidate,
} from "./distributorSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  showDialog,
  formatterStatus,
  checkEmptyFields,
  setOptionsMaster,
  paramsMasterAll,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import { headerSortingClasses, sortCaret } from "../../../_metronic/_helpers";
import BootstrapTable from "react-bootstrap-table-next";
import { fetchTemplate, selectLoadingTemplate } from "../product/productSlice";
import { fetchArea, selectArea } from "../area/areaSlice";
import MultiSelectAll from "../../utility/MultiSelectAll";
import { fetchCompany, selectDataCompany } from "../company/companySlice";

export const DistributorCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const { id } = useParams();
  const ref = useRef();
  const user = useSelector(selectUser);
  const dataId = useSelector(selectId);
  const dataArea = useSelector(selectArea);
  const dataCompany = useSelector(selectDataCompany);

  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [company, setCompany] = useState("");
  const [area, setArea] = useState("");

  const [optionsArea, setOptionArea] = useState([]);

  const paramsId = {
    distributor_id: id,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
        await dispatch(fetchArea({ ...paramsMasterAll }));
      }
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      setName(dataId.distributor_name);
      setCode(dataId.distributor_code);
    }
  }, [dataId]);

  console.log(dataArea, "dataArea");

  // useEffect(() => {
  //   if (dataArea.length > 0) {
  //     setOptionsMaster(
  //       dataArea,
  //       setOptionArea,
  //       "pricipal_area_id",
  //       "area_name"
  //     );
  //   }
  // }, [dataArea]);

  const handleSave = async () => {
    const fields = [
      { value: name, message: "input Name", valid: true },
      { value: code, message: "input Code", valid: true },
    ];

    const errorMessage = checkEmptyFields(fields);
    if (errorMessage) {
      return showDialog(errorMessage);
    }
    const params = {
      distributor_id: id,
      distributor_code: code,
      distributor_name: name,
    };
    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleChangeArea = createChangeHandler(setArea);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined ? "Create Distributor" : "Edit Distributor"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>

            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Company Code</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control type="text" disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Area <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionsArea}
                      value={getValueStatus(area, optionsArea)}
                      placeholder="Select ..."
                      onChange={handleChangeArea}
                      isClearable={true}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Company Name</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control type="text" disabled />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        </CardBody>
      </Card>
    </>
  );
};
